import axios from 'axios';
//import { toast } from 'react-toastify';
import toast from '../utils/toast';

export let API_URL = '/api';
if (process.env.NODE_ENV === 'development') {
  API_URL = 'http://localhost:5000/api';
}
//API_URL = 'http://localhost:5000/api';
// Create axios instance
const api = axios.create({
  baseURL: API_URL, 
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if it exists
api.interceptors.request.use((config) => {
  let token = localStorage.getItem('token');
  if( !token ) token = localStorage.getItem('publicFormToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle response errors globally
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 403 Forbidden errors (permission denied)
    if (error.response && error.response.status === 403) {
      const errorMessage = error.response.data?.message || 'Access denied. You do not have permission to perform this action.';
      const requiredPermission = error.response.data?.requiredPermission;
      
      if (requiredPermission) {
        toast.error(`${errorMessage} Required permission: ${requiredPermission}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else {
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    }
    
    // Handle 401 Unauthorized errors
    else if (error.response && error.response.status === 401) {
      // Don't automatically logout for dashboard errors - let the component handle it
      const isDashboardRequest = error.config?.url?.includes('/dashboard');
      
      if (!isDashboardRequest) {
        toast.error('Session expired. Please login again.', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        
        // Clear token and redirect to login
        localStorage.removeItem('token');
        localStorage.removeItem('userPermissions');
        window.location.href = '/login';
      }
    }
    
    // Handle other errors
    else if (error.response && error.response.status >= 400) {
      const errorMessage = error.response.data?.message || 'An error occurred. Please try again.';
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
    
    // Handle network errors
    else if (error.code === 'NETWORK_ERROR' || error.code === 'ERR_NETWORK') {
      toast.error('Network error. Please check your connection and try again.', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
    
    return Promise.reject(error);
  }
);

// Auth services
export const authService = {
  register: async (userData) => {
    const response = await api.post('/auth/register', userData);
    return response.data;
  },
  login: async (userData) => {
    const response = await api.post('/auth/login', userData);
    return response.data;
  },
  getCurrentUser: async () => {
    const response = await api.get('/auth/me');
    return response.data;
  },
};

export default api;